<template>
  <calendar-container></calendar-container>
</template>

<script>
import CalendarContainer from "@/components/CalendarContainer";

export default {
  components: {
    CalendarContainer,
  },
  metaInfo: {
    title: "플랜",
  },
};
</script>

<style></style>
